// extracted by mini-css-extract-plugin
module.exports = {"modal":"GenericInputModal_modal__3ItHl","modalHeader":"GenericInputModal_modalHeader__P-xP1"};